export const SET_LOGIN_USER_FAILURE = 'SET_LOGIN_USER_FAILURE';
export const SET_LOGIN_USER_SUCCESS = 'SET_LOGIN_USER_SUCCESS';
export const LOGOUT_STATUS_SUCCESS = 'LOGOUT_STATUS_SUCCESS';
export const SET_TOKEN_ON_REGISTRATION ="SET_TOKEN_ON_REGISTRATION"
export const SET_OTP = 'SET_OTP';

